var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiSparkle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4241 8.00158C12.985 8.50662 11.6338 9.33404 10.4822 10.4847C9.33062 11.6354 8.5041 12.9867 7.99905 14.4257C7.4949 12.9867 6.6666 11.6354 5.51592 10.4838C4.36524 9.33314 3.01397 8.50573 1.57495 8.00068C3.01397 7.49564 4.36524 6.66822 5.51681 5.51754C6.66749 4.36686 7.49491 3.0156 7.99995 1.57568C8.505 3.0156 9.33241 4.36597 10.484 5.51754C11.6347 6.66822 12.9859 7.49564 14.425 8.00068L14.4241 8.00158Z",
    fill: "url(#paint0_linear_5294_3161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5294_3161",
    x1: 5.69558,
    y1: 3.44964,
    x2: 12.2951,
    y2: 7.60625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E64EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSparkle);
export default __webpack_public_path__ + "static/media/ai-sparkle.4f63a298bf168471104857c5208d9acf.svg";
export { ForwardRef as ReactComponent };